import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import format from 'date-fns/format';
import i18next from 'i18next';
import { enUS, es } from 'date-fns/locale'; // Import required locales
import { memo, useEffect, useRef, useState } from 'react';
function getLocale(language) {
  switch (language) {
    case 'mx':
      return es;
      case 'en':
      return enUS;
  }
}

function WidgetNow() {
  const [time, setTime] = useState(new Date());
  const intervalRef = useRef();

  useEffect(() => {
    intervalRef.current = setInterval(update, 1000);
    return () => {
          clearInterval(intervalRef.current);
    };
  });

  function update() {
    setTime(new Date());
  }

  return (
    <Paper className=' rounded-none justify-center' style={{ backgroundColor: '#edca33' }}>
      <div className='text-center '>
        <Typography className='text-16 font-semibold' color='#000000'>
          {format(time, 'MMMM', { locale: getLocale(i18next.language) })}
        </Typography>
        <Typography className='text-56  font-bold ' color='#000000'>
          {format(time, 'd', { locale: getLocale(i18next.language) })}
        </Typography>

        <Typography className=' mt-8 text-16 font-semibold ' color='#000000'>
          {format(time, 'Y', { locale: getLocale(i18next.language) })}
        </Typography>
      </div>
    </Paper>
  );
}

export default memo(WidgetNow);
